<template lang="html">
	<div
	id="pizzaday"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section-container">
	<div class="social-section">
		<img class="section-title" src="@/assets/img/social-dividers/pizzaday.png">
		<div class="pizzaday-gallery">
			<img src="@/assets/img/pizzaday/tweet1.png">
			<div class="thumbnails">
				<img src="@/assets/img/pizzaday/1.jpg">
				<img src="@/assets/img/pizzaday/2.jpg">
				<img src="@/assets/img/pizzaday/3.jpg">
				<img src="@/assets/img/pizzaday/4.jpg">
				<img src="@/assets/img/pizzaday/5.jpg">
				<img src="@/assets/img/pizzaday/6.jpg">
			</div>
		</div>
	</div>
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
    mounted() {
        sal();
    },
}
</script>

<style scoped lang="scss">
.section-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	.social-section {
		display: flex;
		flex-direction: column;
		align-items: center;
		.section-title {
			max-width: 300px;
			padding: 25px;
		}
		.pizzaday-gallery {
			img {
				width:80%;
			}
			.thumbnails {
				display:flex;
				flex-flow: wrap;
				justify-content: center;
				align-items: center;
				img {
					margin: 10px;
					max-width:200px;
					box-shadow: 1px 1px 10px black;
				}
			}
		}
	}
}
    
</style>